module.exports = __webpack_public_path__ + "img/tick.00aff25b.svg";